import styled from 'styled-components';

export const PaymentComponent = styled.div`
  width: 100vw;
  display: flex;
  flex: none;
  flex-direction: column;
  align-items: center;
  font-family: 'Libre Franklin', sans-serif;
  overflow: hidden;
  height: 100vh;
`;

export const MainSection = styled.main`
  display: flex;
  flex: none;
  width: 89.333vw;
  flex-grow: 1;
  flex-direction: column;
  gap: 5vh;
`;

export const ContainerTitleAndIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 4vw;
  height: 5vh;
`;

export const IconConcluded = styled.img`
  width: 8.266vw;
  height: 8.266vw;
`;

export const TextConcluded = styled.h1`
  font-weight: 700;
  font-size: 5.333vw;
  font-family: 'Libre Franklin', sans-serif;
`;

export const ImageBanner = styled.img`
  width: 89.3vw;
  height: 29.3vw;
`;

export const TextBackApp = styled.p`
  font-weight: 500;
  font-size: 5.333vw;
  font-family: 'Libre Franklin', sans-serif;
`;

export const ButtonBackApp = styled.a`
  width: 77.333vw;
  display: inline-block;
  padding: 4vw 6vw;
  text-align: center;
  background-color: black;
  color: white;
  border-radius: 2vw;
  text-decoration: none;
  font-weight: 700;
  font-size: 4.333vw;
  font-family: 'Libre Franklin', sans-serif;
  transition: background-color 0.3s ease;

  &:active {
    opacity: 0.7;
    box-shadow: none;
  }
`;
